


































import Vue from 'vue';
import { default as ColourPicker } from '@/shared/services/color';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class HomeScreenHeader extends Vue {

	@Prop() public brandColour: string;
	@Prop() public homescreenImageUrl: string;
	@Prop() public greetingText: string;
	@Prop() public introductionText: string;

	public isChatBoxOpen: boolean = true;
	public isFullscreen: boolean = false;

	get textColour() {
		return ColourPicker.getContrastingColour(this.brandColour);
	}

}
